export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8019.e81b9204.jpg";